<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CEJM3I/tc-custom/9781460349625.jpg?1697041163009" alt="This image is the cover for the book Hostage Bride"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hostage Bride
      </h1>
      <p class="bookDescription body article font2">
        <p>CAPTIVE IN THE DARK KNIGHT’S CASTLE<br/><br/>Raphael’s heart is thought to be in the grave with his late wife. He’s certainly thankful for the mission to restore King Richard to the throne; it leaves him with no time for distraction. Lady Rosamunde Meldreth is beautiful, vulnerable, and the prey of a dangerous man. As much as Raphael wants to walk away, he’s forced to keep Rosamunde under lock and key in his castle. Raphael’s interest in Rosamunde seems to be purely one of possessionbut then she discovers the dark knight wants to make her his hostage bride</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anne Herries
      </h2>
      
      <p class="authorDescription body article">Linda Sole was started writing in 1976 and writing as Anne Herries, won the 2004 RNA Romance Award and the Betty Neels Trophy. Linda loves to write about the beauty of nature, though they are mostly about love and romance. She writes for her own enjoyment and loves to give pleasure to her readers. In her spare time, she enjoys watching the wildlife that visits her garden. Anne has now written more&#160; fifty books for HMB.&#160; You can visit her website at: www.lindasole.co.u</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin (UK) Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1aa0e12b